import { useAuthenticatedQuery } from '@lounge-fe/auth'
import { Customer } from '@shopify/hydrogen-react/storefront-api-types'
import { UseQueryOptions } from '@tanstack/react-query'
import { useService } from '../../../hooks/useService'
import { AccountDetailsService } from '../services/AccountDetailsService'

type CustomerData = {
  data: Customer & { birthday?: string; gender?: string }
}

export const useCustomer = (
  config: Partial<UseQueryOptions<CustomerData>> = {},
) => {
  const accountDetailsService = useService(new AccountDetailsService())
  return useAuthenticatedQuery({
    queryKey: ['customer'],
    queryFn: async (): Promise<CustomerData> => {
      const { data, ...res } = await accountDetailsService.get()
      return {
        ...res,
        data: {
          ...data,
          birthday: data.metafields.find((field) => field?.key === 'birthday')
            ?.value,
          gender: data.metafields.find((field) => field?.key === 'gender')
            ?.value,
        },
      }
    },
    ...config,
  })
}
